export default __webpack_public_path__ + "static/media/rewards_icon_all.6889350e.svg";